var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.42511C36.8438 0.42511 47.25 10.8314 47.25 23.6751C47.25 36.5189 36.8438 46.9251 24 46.9251C11.1562 46.9251 0.75 36.5189 0.75 23.6751C0.75 10.8314 11.1562 0.42511 24 0.42511ZM24 42.4251C34.3125 42.4251 42.75 34.0814 42.75 23.6751C42.75 13.3626 34.3125 4.92511 24 4.92511C13.5938 4.92511 5.25 13.3626 5.25 23.6751C5.25 34.0814 13.5938 42.4251 24 42.4251ZM29.7188 32.6751L21.75 26.8626C21.4688 26.6751 21.375 26.3001 21.375 26.0189V10.5501C21.375 9.98761 21.8438 9.42511 22.5 9.42511H25.5C26.0625 9.42511 26.625 9.98761 26.625 10.5501V23.8626L32.8125 28.4564C33.375 28.8314 33.4688 29.4876 33.0938 30.0501L31.3125 32.3939C30.9375 32.9564 30.2812 33.0501 29.7188 32.6751Z",
    fill: "#1A73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.83ac7f973ddcc9f3466ed3a0d07cfab9.svg";
export { ForwardRef as ReactComponent };